/* unplugin-vue-components disabled */import { render } from "./StereoscopicSectionExamShot.vue?vue&type=template&id=40d11237&scoped=true"
import script from "./StereoscopicSectionExamShot.vue?vue&type=script&lang=js"
export * from "./StereoscopicSectionExamShot.vue?vue&type=script&lang=js"

import "./StereoscopicSectionExamShot.vue?vue&type=style&index=0&id=40d11237&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40d11237"]])

export default __exports__